import React from 'react';
import LogoIcon from '../common/Logo/LogoIcon/LogoIcon';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';

interface LogoContainerProps {
  title: string;
}

const logoSize = '48px';

export default function LogoContainer({ title }: LogoContainerProps) {
  return (
    <Flex flexDirection="column" alignItems="center">
      <Flex justifyContent="center">
        <div style={{ width: logoSize, height: logoSize, maxHeight: logoSize, maxWidth: logoSize }}>
          <LogoIcon height={logoSize} width={logoSize} />
        </div>
      </Flex>
      <Text
        variant="h4"
        textAlign="center"
        transform="uppercase"
        fontWeight={600}
        sx={{ fontFamily: "'Geist'", fontSize: '26px', marginTop: '8px', color: colors.darkBlue }}
      >
        {title}
      </Text>
    </Flex>
  );
}
